import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    min-width: 300px;
    max-width: 500px;
    margin-top: 15px;
`;
